import FileSaver from 'file-saver';

export const exportExcel = (data: any) => {
    import('xlsx').then((xlsx: any) => {
        const worksheet = xlsx.utils.json_to_sheet(data);
        const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
        const excelBuffer = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
        saveAsExcelFile(excelBuffer, 'ToDoView');
    });
};
export const saveAsExcelFile = (buffer: any, fileName: any) => {
    const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const EXCEL_EXTENSION = '.xlsx';
    const data = new Blob([buffer], {
        type: EXCEL_TYPE,
    });
    FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
};

export const GetTeamOptions = (role: string,isPseudoSupervisor:boolean) => {
    const teamOptions: any = [];
    teamOptions.push({ name: `My ToDo's`, code: 'myActivity' });
    if (role !== 'Non-Manager'||isPseudoSupervisor===true) {
        teamOptions.push({ name: 'My Team', code: 'myTeamActivity' });
    }
    if (role !== 'Non-Manager'||isPseudoSupervisor===true)
        teamOptions.push({ name: 'Search', code: 'search' });
    return teamOptions;
}

export const getRole = (role: string,isPseudoSupervisor:boolean) => {

    if (isPseudoSupervisor===true) return 'supervisor';

    if (role === 'Non-Manager') return 'associate';
    else if (role === 'Supervisor 1' || role === 'Supervisor 2') return 'supervisor';
    else if (role === 'Manager 1' || role === 'Manager 2') return 'manager';
    else if (role !== '' && role !== 'Non-Manager' && role !== 'Supervisor 1'&& role !== 'Supervisor 2'&& role !== 'Manager 1'&& role !== 'Manager 2') return 'director';
    else return '';
}